var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_1262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.559482 9.88148C0.559061 11.3938 0.957311 12.8705 1.71458 14.1721L0.487061 18.6192L5.07369 17.4259C6.34228 18.1112 7.76366 18.4702 9.20806 18.4703H9.21186C13.9801 18.4703 17.8616 14.6204 17.8636 9.88825C17.8645 7.5952 16.9654 5.43897 15.3317 3.81673C13.6984 2.19464 11.5261 1.30085 9.21151 1.2998C4.4427 1.2998 0.561521 5.14957 0.559553 9.88148",
    fill: "url(#paint0_linear_425_1262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.250527 9.87875C0.250035 11.4455 0.662559 12.975 1.44682 14.3232L0.175293 18.9297L4.92638 17.6937C6.23546 18.4019 7.70935 18.7753 9.20911 18.7758H9.21298C14.1523 18.7758 18.1732 14.7874 18.1753 9.88586C18.1761 7.51042 17.2446 5.27668 15.5526 3.59633C13.8604 1.91619 11.6104 0.990235 9.21298 0.989258C4.27282 0.989258 0.252566 4.97717 0.250598 9.87875H0.250527ZM3.0799 14.091L2.9025 13.8116C2.15677 12.635 1.76316 11.2754 1.76372 9.8793C1.76534 5.80523 5.10687 2.49065 9.21579 2.49065C11.2056 2.49149 13.0757 3.26116 14.4822 4.65763C15.8887 6.05423 16.6626 7.91075 16.6621 9.8853C16.6603 13.9594 13.3187 17.2744 9.21298 17.2744H9.21003C7.87318 17.2737 6.56206 16.9174 5.41864 16.2443L5.14653 16.0841L2.32714 16.8176L3.0799 14.091V14.091Z",
    fill: "url(#paint1_linear_425_1262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97292 6.16254C6.80515 5.79256 6.6286 5.7851 6.46906 5.77861C6.33842 5.77303 6.18908 5.77344 6.03987 5.77344C5.89053 5.77344 5.64788 5.82919 5.44278 6.0514C5.23747 6.27382 4.65894 6.81131 4.65894 7.90449C4.65894 8.99775 5.46141 10.0542 5.57328 10.2026C5.68529 10.3507 7.12247 12.6659 9.39863 13.5566C11.2903 14.2967 11.6753 14.1495 12.0858 14.1124C12.4965 14.0754 13.4108 13.575 13.5973 13.0562C13.784 12.5374 13.784 12.0927 13.7281 11.9998C13.6721 11.9072 13.5227 11.8516 13.2988 11.7405C13.0748 11.6294 11.9738 11.0918 11.7686 11.0177C11.5633 10.9436 11.414 10.9066 11.2647 11.1291C11.1153 11.3512 10.6865 11.8516 10.5558 11.9998C10.4252 12.1483 10.2945 12.1668 10.0706 12.0557C9.84652 11.9442 9.12533 11.7098 8.26969 10.9529C7.60397 10.3639 7.15454 9.63661 7.0239 9.41412C6.89326 9.19198 7.0099 9.07156 7.12219 8.96084C7.22281 8.86128 7.34621 8.70138 7.45829 8.57168C7.56994 8.44191 7.60721 8.34933 7.68188 8.20114C7.75662 8.05282 7.71922 7.92305 7.66332 7.81191C7.60721 7.70077 7.17204 6.60193 6.97292 6.16261",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_425_1262",
    x1: 9.17533,
    y1: 18.6192,
    x2: 9.17533,
    y2: 1.2998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_425_1262",
    x1: 9.17529,
    y1: 18.9297,
    x2: 9.17529,
    y2: 0.989258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_1262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.175293 0.989258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.bfaac7565fde15bde733b948745af5af.svg";
export { ForwardRef as ReactComponent };